<template>
  <div class="leftMenu" :class="spanLeft">
    <Row class="menuContainer normalTop">
      <Col>
        <Menu ref="leftMenu" :active-name="active" :v="active" width="auto" @on-select="routeTo" :open-names="openNames"
              :theme="theme2">
          <template v-for="(item, index) in menuMap">
            <!-- 没有分组的业务 -->
            <template v-if="item.type === 'noGroup'">
              <Submenu :name="index" :key="index">
                <template slot="title">
                  <span class="icon iconfont" :class="item.icon"></span>
                  {{item.mainTitle}}
                </template>
                <template v-for="(subItem, subIndex) in menuMap">
                  <template v-if="subItem.pid === item.id" >
                    <Menu-item :name="item.id + '-' + subItem.id" :key="subIndex+'_'+index">
                      {{subItem.mainTitle}}
                    </Menu-item>
                  </template>
                </template>
              </Submenu>
            </template>
            <!-- 有分组的业务 -->
            <template v-else-if="item.type === 'Group'" v-for="(subItem2, subItemIndex) in menuMap">
              <template v-if="subItem2.type === 'Group-title' || subItem2.type === 'Group-base' || subItem2.type === 'Group-biz' || subItem2.type === 'Group-access'">
                <Submenu :name="subItemIndex+'_'+index" :key="subItemIndex+'_'+index">
                  <template slot="title">
                    <!--<span class="icon iconfont" :class="subItem.icon"></span>-->
                    <Icon v-if="subItem2.type === 'Group-title' || subItem2.type === 'Group-base'" type="ios-people" />
                    <Icon v-if="subItem2.type === 'Group-biz'" type="android-subway" />
                    <Icon v-if="subItem2.type === 'Group-access'" type="podium" />
                    {{subItem2.mainTitle}}
                  </template>
                  <template v-for="(dataItem, dataItemIndex) in menuMap">
                    <template v-if="subItem2.id === dataItem.pid">
                      <Menu-item :name="subItem2.id + '-' + dataItem.id" :key="dataItemIndex+'_'+subItemIndex+'_'+index" v-if="dataItem.secondMenu !== 'second-menu'">
                        {{dataItem.mainTitle}}
                        <span v-if="dataItem.dataItemNum" class="numMark">{{dataItem.dataItemNum}}</span>
                      </Menu-item>
                      <!-- 二级导航 -->
                      <Submenu v-if="dataItem.secondMenu === 'second-menu'" :name="dataItemIndex" :key="dataItemIndex+'_'+subItemIndex+'_'+index">
                        <template slot="title">{{dataItem.mainTitle}}</template>
                        <template v-for="(d, i) in menuMap">
                          <Menu-item :name="dataItem.id + '-' + d.id" v-if='d.pid === dataItem.id' :key="i+'_'+dataItemIndex+'_'+subItemIndex+'_'+index">
                            {{d.mainTitle}}
                          </Menu-item>
                        </template>
                      </Submenu>
                    </template>
                  </template>
                </Submenu>
              </template>
              <template v-else-if="!(subItem2.type === 'Group-title' || subItem2.type === 'Group-base' || subItem2.type === 'Group-biz' || subItem2.type === 'Group-access') && item.id === subItem2.pid">
                <div class="singlePage" :key="subItemIndex+'_'+index">
                  <Menu-item :name="item.id + '-' + subItem2.id" :v="item.id + '-' + subItem2.id">
                    <span class="icon iconfont" :class="subItem2.icon"></span>
                    {{subItem2.mainTitle}}
                    <span v-if="subItem2.dataItemNum" class="numMark">{{subItem2.dataItemNum}}</span>
                  </Menu-item>
                </div>
              </template>
            </template>
          </template>
        </Menu>
      </Col>
    </Row>
  </div>
</template>
<script>
import locale from '@/api/menuLanguage';
import menuLogisticProvider from '@/api/menuLogisticProvider';
import menuOwLogisticProvider from '@/api/menuOwLogisticProvider';
import menuSeller from '@/api/menuSeller';
import menuAdmin from '@/api/menuAdmin';
import indexAdmin from '@/api/indexAdmin';
import layoutMixin from '@/components/mixin/layout_mixin';
import api from '@/api/api';
export default {
  mixins: [ layoutMixin ],
  data () {
    return {
      menuMap: [],
      userId:'',
      catchMap: null,
      breadcrumbObj: [],
      openNames: [],
      theme2: 'light',
      liv: true,
      msgResponseFlag: false,
      dispatchResponseFlag: false
    };
  },
  computed: {
    active () {
      return this.$store.state.active;
    },
    spanLeft () {
      return this.$store.state.spanLeft !== 0 ? 'ivu-col-span-' + this.$store.state.spanLeft : '';
    },
    clickStatus () {
      return this.$store.state.clickStatus;
    },
    roleData () {
      return this.$store.state.roleData;
    }
  },
  watch: {
    clickStatus (n) {
      let v = this;
      if (n) {
        v.setMenu();
      }
    }
  },
  created () {
    let v = this;
    let menu;
    let inGroup = this.$store.state.inGroup;
    switch (inGroup) {
      case 'logisticsProvider' :
        menu = menuLogisticProvider;
        v.menuMap = menu[inGroup];
        v.setMenu();
        v.getLogisMenuInfo();
        break;
      case 'seller':
        menu = menuSeller;
        v.menuMap = menu[inGroup];
        v.setMenu();
        break;
      case 'adminService':
        v.getUserInfo(inGroup);
        break;
      case 'index':
        menu = indexAdmin;
        v.menuMap = menu[inGroup];
        v.setMenu();
        break;
    }
    
  },
  methods: {
    setMenu () {
      let v = this;
      let lenPos = []; // 展开POS
      let thisPage = v.$store.state.thisPage;
      v.menuMap.forEach((n, i) => {
        lenPos.push(i);
        if (n.link !== undefined && v.getLastPageName(n.link) === thisPage) {
          if (n.pid && n.pid !== 0) {
            v.$nextTick(function () {
              var activeValue = n.pid + '-' + n.id;
              v.$store.commit('active', activeValue);
            });
          } else {
            v.$nextTick(function () {
              v.$store.commit('active', n.id);
            });
          }
        }
      });
      v.$store.commit('clickStatus', false);
      v.openNames = lenPos;
      this.$nextTick(function () {
        this.$refs.leftMenu.updateOpened();
        this.$refs.leftMenu.updateActiveName();
      });
    },
    getLogisMenuInfo() {
      let v = this;
      let menu;
      let inGroup = this.$store.state.inGroup;
      if (inGroup === 'logisticsProvider'){
        v.axios.post(api.warehouse_menuStatus)
        .then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data !== null && data.indexOf("1|") !== -1) {
              menu = menuOwLogisticProvider;
            } else {
              menu = menuLogisticProvider;
            }
            v.menuMap = menu[inGroup];
            if (data !== null) {
              let ary = data.split("|");
              if(ary.length > 1 && ary[1] === 'logi_service') {
                v.menuMap.push({
                  'mainTitle': locale.logisticsMenu.accessStatistics,// 访问管理
                  'id': 26,
                  'icon': '',
                  'pid': 18,
                  'link': '/logisticsProvider.html#/accessStatistics',
                  'menuKey': 'accessStatistics'
                });
              }
            }
            
            v.setMenu();
          }
        });
      }
    },
    getUserInfo(inGroup){
      let v = this;
      v.axios.get(api.getUserAuth)
          .then(response => {
            if (response.data.code === 0) {
              v.userId = response.data.datas.userId;
              sessionStorage.setItem('userId', response.data.datas.userId);
              var authType = response.data.datas.authType;
              console.log("aa="+authType);
              v.$store.commit('authType', authType); 
              v.showMenu(inGroup,authType);
            }
      });
    },
    showMenu(inGroup,_authType){
      let v = this;
      if (_authType === "admin"){ // 超级管理员
        v.menuMap = menuAdmin[inGroup];
      } else if (_authType === "normalAdmin") {
        v.menuMap.push({
          'mainTitle': locale.logisticsMenu.logisCurrentPosition, // 当前位置
          'link': '/admin.html#/',
          'type': 'Group', // 没有子菜单
          'alias': 'logisManagement',
          'id': 11
        });
        v.menuMap.push({
            'mainTitle': locale.logisticsMenu.logisManagement, // 物流管理
            'type': 'Group-title',
            'icon': 'icon-shenhe',
            'id': 12,
            'pid': 11
        });
        v.menuMap.push(
          {
              'mainTitle': locale.logisticsMenu.carrierParam,// 物流信息管理
              'id': 20,
              'pid': 12,
              'link': '/admin.html#/carrierInfo',
              'menuKey': 'carrierInfo'
          }
        );
        v.menuMap.push(
          {
              'mainTitle': locale.logisticsMenu.packageInfo,// 包裹信息管理
              'id': 21,
              'pid': 12,
              'link': '/admin.html#/packageInfo',
              'menuKey': 'packageInfo'
          }
        );
        v.menuMap.push(
          {
              'mainTitle': locale.logisticsMenu.logManagement,// 日志管理
              'id': 22,
              'pid': 12,
              'link': '/admin.html#/logManagement',
              'menuKey': 'logManagement'
          }
        );
      }
      v.setMenu();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/layout/left.vue